import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles'
import SuggestSelectInput from '../../../Common/suggestSelectInput';
import Validator from '../../../Common/validator'

class EmailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: [
        {
          touched: false,
          id: "",
          name: ""
        }
      ]
    }
  }
  handleYes = () => {
    let validEmails = [];
    this.state.emails.forEach((email) => {
      if(email.name){
        validEmails.push(email.name)
      }
    })
    this.props.onSend(validEmails);
  };
  onEmailBlur = (index) => {
    let emails = [...this.state.emails];
    emails[index].touched = true;
    this.setState({
      emails: emails
    })
  };
  onEmailChange = (index, val) => {
    let emails = [...this.state.emails];
    emails[index].name = val.name;
    emails[index].id = val.name;
    //if index is last one, add another email
    if(index===emails.length-1)
      emails.push({touched: false, id: "", name: ""})
    this.setState({
      emails: emails
    })
  };
  isEmailValid = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
  render() {
    const { closeModal, getEmailSuggestions, emailSuggestions, isSending } = this.props;
    let isEmailsValid = true;
    let atleastOneValid = false;
    let emailNodes = this.state.emails.map((email, index) => {
      let isEmailValid = (!email.touched || this.isEmailValid(email.name) || email.name==="");
      if(!isEmailValid)
        isEmailsValid = false
      else if(isEmailValid && this.isEmailValid(email.name))
        atleastOneValid = true
      return (
        <div key={index} style={styles.email}>
          <Validator
            isValid={isEmailValid}
          >
            <SuggestSelectInput
              onQuery={(val) => getEmailSuggestions(val, this.state.emails)}
              suggestions={email.name ? emailSuggestions : []}
              placeholder="..."
              onChange={(val) => {
                this.onEmailChange(index, val)
              }}
              value={email}
              onBlur={() => this.onEmailBlur(index)}
            />
          </Validator>
        </div>
      )
    })

    return(
      <div>
        <div style={styles.overlay}></div>
          <div style={styles.wizardContainer}>
          {this.props.showEmailConfirmation ?
            <div style={styles.confirmationContainer}> 
              <i className="fa fa-envelope-o" style={styles.envelope} aria-hidden="true"></i> 
              <div style={styles.confirmatonMessage}>Din email er sendt!</div>
              <button style={styles.lukBtn} className="btn btn-primary waves-btn" onClick={closeModal}> Luk </button>
            </div> 
            :
            <div>
              <div>
                <div style={styles.heading}>Send Dagrapport med email</div>
                <div style={styles.textContainer}>
                  <div>Til</div>
                  {
                    emailNodes
                  }
                </div>
              </div>
              <div style={styles.buttonsContainer}>
                <button style={styles.buttons} className="btn btn-primary waves-btn" onClick={closeModal}> Annuller </button>
                <button
                  style={styles.buttons}
                  className={isEmailsValid && atleastOneValid ? "btn btn-success waves-btn" : "btn btn-default waves-btn"}
                  onClick={this.handleYes}
                  disabled={!isEmailsValid || !atleastOneValid}
                >  
                {isSending ? <i className="fa fa-spinner fa-spin" style={styles.spinner}/> : <span>Send</span>}
                </button>
              </div>
            </div>
          }
      </div>
    </div>
    )
  }
}

var styles = {
  overlay: {
    width:'100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    backgroundColor: greyScaleColors.grey,
    opacity: '0.6',
    zIndex: '10'
  },
  wizardContainer:{
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: '11',
    backgroundColor: semanticColors.default,
    width: '550px',
    minHeight: '200px',
    marginTop: '-165px',
    marginLeft: '-329px',
    padding: '20px 30px 60px 30px'
  },
  confirmationContainer:{
    textAlign: 'center',
    height: '110px',
    lineHeight: '110px'
  },
  confirmatonMessage:{
    display: 'inline',
    fontSize: '18px'
  },
  envelope: {
    fontSize: '24px',
    marginRight: '10px'
  },
  lukBtn:{
    width: '145px',
    height: '35px',
    position: 'absolute',
    bottom: '20px',
    right: '20px'
  },
  heading : {
    borderBottom: '1px solid' + semanticColors.mainBackground,
    paddingBottom: '5px',
    paddingLeft: '5px',
    fontWeight : '800'
  },
  textContainer : {
    paddingTop: '20px'
  },
  buttonsContainer : {
    textAlign : 'right',
    position: 'absolute',
    right: '30px',
    bottom: '20px'
  },
  buttons: {
    width: '145px',
    height: '35px',
    marginLeft: '10px'
  },
  spinner: {
    display: 'block',
    fontSize: '22px'
  },
  email: {
    marginBottom: '10px'
  }
}
  EmailModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
    getEmailSuggestions: PropTypes.func.isRequired,
    emailSuggestions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }))
  };
export default Radium(EmailModal)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/emailModal.jsx